import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Buffer } from "buffer";
import AWS from "aws-sdk";
import * as Icon from "react-feather";
import { backendApi, backendApiS3Credential } from "../../api/apiService";
import { FaCamera, FaTrash, FaEye } from "react-icons/fa";
import Avatar from "react-avatar-edit";
import defaultImg from "../../images/defaultImg.png";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "../../components/hooks/hooks";
import { awsConfig } from "../../config";
import { setAwsConfigData } from "../../redux/reducers/masterDataSlice";
import Switch from "react-switch";
import moment from "moment";
import PlaceHolder from "../../images/placeholder.png";
import { uploadToS3 } from "../../api/apiService";

const S3BucketImagesFolder = "images";
var s3;

const SiteDetails = () => {
  const dispatch = useDispatch();
  const { awsData, recuitmentStatus } = useSelector(
    (state) => state.commonData
  );
  const [siteDetails, setSiteDetails] = useState({});
  const [documentDetails, setDocumentDetails] = useState();
  const [documents, setDocuments] = useState();
  const [regions, setRegions] = useState([]);
  const navigate = useNavigate();
  const [imagecrop, setimagecrop] = useState(false);
  const [pview, setpview] = useState(false);
  const [profile, setprofile] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [hasDp, setHasDp] = useState(false);
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  const [files, setFiles] = useState();
  const [filesLogo, setFilesLogo] = useState(null);
  const [watermarkLogo, setWatermarkLogo] = useState(null);
  const [companySeal, setCompanySeal] = useState(null);
  const [hrSign, setHrSign] = useState(null);
  const [ctoSign, setCtoSign] = useState(null);

  const companyTypes = [
    "IT",
    "Product",
    "Consulting",
    "Enterprise",
    "Financial Services",
    "Healthcare",
    "Manufacturing",
    "Retail",
    "Media and Entertainment",
    "Education",
    "Transportation",
    "Nonprofit Organization",
    "Government Agency",
  ];

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("SiteMenu").classList.add("active");
    }, 500);
    getSiteDetails();
    getS3Credentials();
    getDocumentDetails();
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  const saveDetails = () => {
    var flag = true;
    if (!siteDetails.company_name) {
      toast.warn("Company Name Required", { containerId: "F" });
      document.getElementById("company_name").focus();
      flag = false;
    } else if (!siteDetails.email_id) {
      toast.warn("Email Id Required", { containerId: "F" });
      document.getElementById("email_id").focus();
      flag = false;
    } else if (!siteDetails.address) {
      toast.warn("Address Required", { containerId: "F" });
      document.getElementById("address").focus();
      flag = false;
    } else if (
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(
        siteDetails.email_id
      )
    ) {
      toast.warn("Invalid Email Address", { containerId: "F" });
      document.getElementById("email_id").focus();
      flag = false;
    } else if (!siteDetails.contact_no) {
      toast.warn("Contact Number Required", { containerId: "F" });
      document.getElementById("contact_no").focus();
      flag = false;
    } else if (!siteDetails.mobile_no) {
      toast.warn("Mobile Number Required", { containerId: "F" });
      document.getElementById("mobile_no").focus();
      flag = false;
    } else if (!/^[0-9]/.test(siteDetails.mobile_no)) {
      toast.warn("Invalid Mobile Number", { containerId: "F" });
      document.getElementById("mobile_no").focus();
      flag = false;
    } else if (!siteDetails.company_type) {
      toast.warn("Company Type Required", { containerId: "F" });
      document.getElementById("company_type").focus();
      flag = false;
    } else if (!siteDetails.zip) {
      toast.warn("Zipcode Required", { containerId: "F" });
      document.getElementById("zip").focus();
      flag = false;
    } else if (!siteDetails.website_url) {
      toast.warn("Website URL Required", { containerId: "F" });
      document.getElementById("website_url").focus();
      flag = false;
    }
    const currentDate = new Date().toISOString();
    if (flag === true) {
      const req = {
        functionName: "siteUpdate",
        site_id: localStorage.getItem("siteId"),
        company_name: siteDetails.company_name,
        address: siteDetails.address,
        email_id: siteDetails.email_id,
        contact_no: siteDetails.contact_no,
        mobile_no: siteDetails.mobile_no,
        company_type: siteDetails.company_type,
        region_id: "",
        email_notification: 0,
        sms_notification: 0,
        email_service: 0,
        created_on: currentDate,
        logo_url: siteDetails.logo_url,
        zip: siteDetails.zip,
        website_url: siteDetails.website_url,
      };
      console.log("req", req);
      backendApi(req).then((data) => {
        if (data.success === "1") {
          //   setUserDetaisData(data?.stage[0]);
          getSiteDetails();
          toast.success("Your Changes Saved Successfully ", {
            containerId: "F",
          });
        } else {
          toast.warn("Something went wrong", { containerId: "F" });
          //   getUserDetails();
        }
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSiteDetails((prevUserDetails) => ({
      ...prevUserDetails,
      [name]: value,
    }));
  };

  const handleImageError = (event) => {
    // If the image fails to load, set the source to the default image
    event.target.src = defaultImg;
  };

  const onCrop = (view) => {
    if (view) {
      setpview(view);
    }
  };
  const onClose = () => {
    setpview(null);
  };

  const saveCropImage = () => {
    if (pview) {
      handleImageUpload();
      setprofile([...profile, { pview }]);
      setimagecrop(false);
    } else {
      toast.warn("Please select an image", { containerId: "A" });
    }
  };

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const handleImageUpload = async (files) => {
    const webpBuffer = convertBase64ToBuffer(pview, "webp");
    const fileName = uuidv4();
    const fullFilePath = S3BucketImagesFolder + "/" + fileName + ".webp";
    try {
      // const data = await s3
      //   .upload({
      //     Key: fullFilePath,
      //     Body: webpBuffer,
      //     ACL: "public-read",
      //     ContentType: "image/webp",
      //   })
      //   .promise();
      // setSiteDetails((prevUserDetails) => ({
      //   ...prevUserDetails,
      //   ["logo_url"]: data.Location,
      // }));
      const data = await uploadToS3(files);
      setSiteDetails((prevUserDetails) => ({
        ...prevUserDetails,
        ["logo_url"]: data,
      }));
    } catch (err) {
      console.error("Error occurred during image upload", err);
      return;
    }
  };

  const removePic = () => {
    var request = {
      functionName: "pofileUpdate",
      // id: user_id,
      // first_name: formattedFirstName,
      // last_name: formattedLastName,
      // address: address,
      // mobile_no: phone,
      // designation: designation,
      // profileImage: "",
    };
    backendApi(request).then((response) => {
      if (response?.success === "1") {
        toast.success("Profile Picture Removed", { containerId: "A" });
        setIsDropdownVisible(false);
      } else {
        toast.error(response.errorMessage, { containerId: "A" });
      }
    });
  };
  const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const convertBase64ToBuffer = (base64Url, format = "webp") => {
    const base64Data = base64Url.split(",")[1];
    const buffer = Buffer.from(base64Data, "base64");
    return buffer;
  };

  const getSiteDetails = () => {
    const apiSave = {
      functionName: "getSitedata",
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(apiSave).then((data) => {
      if (data.success === "1") {
        setSiteDetails(data.stage);
      } else {
        console.log("Error site details");
      }
    });
  };

  const getS3Credentials = () => {
    // const credentialReq = {
    //   functionName: "s3Credentials",
    // };
    // backendApiS3Credential(credentialReq).then((data) => {
    // s3Region = "ap-south-1";
    // s3bucketAccessKey = data.data[0].s3bucketAccessKey;
    // s3bucketSecretKey = data.data[0].s3bucketSecretKey;
    // s3Bucket = "bugiffy-prod";
    // bucketParams = {
    //   Bucket: s3Bucket,
    // };
    // AWS.config.update({
    //   accessKeyId: s3bucketAccessKey,
    //   secretAccessKey: s3bucketSecretKey,
    //   region: s3Region,
    // });
    // s3 = new AWS.S3({
    //   apiVersion: "2006-03-01",
    //   params: bucketParams,
    // });
    // });
    const bucketParams = {
      Bucket: awsConfigDataState.s3Bucket,
    };
    AWS.config.update({
      accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
      region: "us-east-1",
    });
    s3 = new AWS.S3({
      apiVersion: "2006-03-01",
      params: bucketParams,
    });
  };

  const handleDocumentTypeChange = (event) => {
    console.log("Pathhh", event);
    setDocumentDetails(event.target.value);
  };
  useEffect(() => {
    if (awsConfigDataState) {
      console.log(
        "🚀 ~ file: resumeUpload.jsx:151 ~ useEffect ~ awsConfigDataState:",
        awsConfigDataState
      );

      if (awsData !== "default") dispatch(setAwsConfigData(awsConfigDataState));
      const bucketParams = {
        Bucket: awsConfigDataState.s3Bucket,
      };
      AWS.config.update({
        accessKeyId: awsConfigDataState.s3BucketAccessKey,
        secretAccessKey: awsConfigDataState.s3bucketSecretKey,
        region: "us-east-1",
      });
      s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: bucketParams,
      });
      console.log("🚀 ~ file: resumeUpload.jsx:169 ~ useEffect ~ s3:", s3);
    }
  }, []);

  const handleFileUpload = (e) => {
    setFiles(e.target.files[0]);
  };
  const handleFileUploadLogo = (e) => {
    setFilesLogo(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const handleFileUploadWatermarkLogo = (e) => {
    setWatermarkLogo(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const handleFileUploadComapnySeal = (e) => {
    setCompanySeal(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const handleFileUploadHrSign = (e) => {
    setHrSign(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const handleFileUploadCtoSign = (e) => {
    setCtoSign(e.target.files[0]);
    console.log(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    if (files) {
      try {
        const bucketParams = {
          Bucket: awsConfigDataState.s3Bucket,
        };
        AWS.config.update({
          accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
          secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
          region: "us-east-1",
        });
        s3 = new AWS.S3({
          apiVersion: "2006-03-01",
          params: bucketParams,
        });
        const timestamp = Date.now();
        const modifiedFileName = `${files.name}_${timestamp}`;
        const data = await s3
          .upload({
            Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${modifiedFileName}`,
            Body: files,
            ACL: "public-read",
          })
          .promise();
        console.log("Pathhh", data.Location);
        const apiSave = {
          functionName: "saveSiteDoc",
          site_id: localStorage.getItem("siteId"),
          created_by: localStorage.getItem("userId"),
          doc_name: documentDetails,
          doc_url: `${data.Location}`,
        };
        console.log("aaaaa", apiSave);
        backendApi(apiSave).then((data) => {
          if (data.success === "1") {
            getDocumentDetails();
          } else {
            console.log("Error site details");
          }
        });
      } catch (err) {
        console.error("err", err);
        return;
      }
    } else {
      toast.warn("Please choose a file to upload", { containerId: "F" });
    }
  };

  const handleUploadLogo = async (e) => {
    if (filesLogo) {
      try {
        // const bucketParams = {
        //   Bucket: awsConfigDataState.s3Bucket,
        // };
        // AWS.config.update({
        //   accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
        //   secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
        //   region: "us-east-1",
        // });
        // s3 = new AWS.S3({
        //   apiVersion: "2006-03-01",
        //   params: bucketParams,
        // });
        // const timestamp = Date.now();
        // const startDateTime = moment(timestamp).startOf("day");
        // const formattedTimeStamp = startDateTime.format("DD MMM YYYY h:mm A");
        // const modifiedFileName = `${filesLogo.name}_${formattedTimeStamp}`;
        // const data = await s3
        //   .upload({
        //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${modifiedFileName}`,
        //     Body: filesLogo,
        //     ACL: "public-read",
        //   })
        //   .promise();
        const data = await uploadToS3(filesLogo);
        console.log("Pathhh", data.Location);
        let companyLogo = data;
        const currentDate = new Date().toISOString();
        const req = {
          functionName: "siteUpdate",
          site_id: localStorage.getItem("siteId"),
          company_name: siteDetails.company_name,
          address: siteDetails.address,
          email_id: siteDetails.email_id,
          contact_no: siteDetails.contact_no,
          mobile_no: siteDetails.mobile_no,
          company_type: siteDetails.company_type,
          region_id: "",
          email_notification: 0,
          sms_notification: 0,
          email_service: 0,
          created_on: currentDate,
          logo_url: siteDetails.logo_url,
          zip: siteDetails.zip,
          website_url: siteDetails.website_url,
          company_logo: companyLogo,
          company_seal: siteDetails.company_seal,
          hr_sign: siteDetails.hr_sign,
          cto_sign: siteDetails.cto_sign,
          watermark_logo: siteDetails.watermark_logo,
        };
        console.log("aaaaa", req);
        backendApi(req).then((data) => {
          if (data.success === "1") {
            toast.success("Logo uploaded successfully", { containerId: "F" });
            localStorage.setItem("logo", companyLogo);
          } else {
            console.log("Error site details");
          }
        });
      } catch (err) {
        console.error("err", err);
        return;
      }
    } else {
      toast.warn("Please choose a file to upload", { containerId: "F" });
    }
  };

  const getDocumentDetails = () => {
    const apiSave = {
      functionName: "listSiteDoc",
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(apiSave).then((data) => {
      if (data.success === "1") {
        console.log(data);
        setDocuments(data.dataSet);
      } else {
        console.log("Error site details");
      }
    });
  };

  const changeActive = (event, document) => {
    setDocuments(
      documents.map((obj) => {
        if (document.id === obj.id) {
          return {
            ...obj,
            is_active: event === true ? 1 : 0,
          };
        }
        return obj;
      })
    );
    var req = {
      functionName: "activeDeactiveSiteDoc",
      site_doc_id: document.id,
      is_active: event,
    };
    console.log(req);
    backendApi(req).then((response) => {
      if (response.success !== 1) {
        console.log("error while fetching openings");
        return false;
      }
    });
  };

  const openFileInNewTab = (document) => {
    window.open(document.doc_url, "_blank");
  };

  const handleUploadWatermarkLogo = async (e) => {
    if (watermarkLogo) {
      try {
        // const bucketParams = {
        //   Bucket: awsConfigDataState.s3Bucket,
        // };
        // AWS.config.update({
        //   accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
        //   secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
        //   region: "us-east-1",
        // });
        // s3 = new AWS.S3({
        //   apiVersion: "2006-03-01",
        //   params: bucketParams,
        // });
        // const timestamp = Date.now();
        // const startDateTime = moment(timestamp).startOf("day");
        // const formattedTimeStamp = startDateTime.format("DD MMM YYYY h:mm A");
        // const modifiedFileName = `${watermarkLogo.name}_${formattedTimeStamp}`;
        // const data = await s3
        //   .upload({
        //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${modifiedFileName}`,
        //     Body: watermarkLogo,
        //     ACL: "public-read",
        //   })
        //   .promise();
        const data = await uploadToS3(watermarkLogo);
        console.log("Pathhh", data);
        const currentDate = new Date().toISOString();
        const req = {
          functionName: "siteUpdate",
          site_id: localStorage.getItem("siteId"),
          company_name: siteDetails.company_name,
          address: siteDetails.address,
          email_id: siteDetails.email_id,
          contact_no: siteDetails.contact_no,
          mobile_no: siteDetails.mobile_no,
          company_type: siteDetails.company_type,
          region_id: "",
          email_notification: 0,
          sms_notification: 0,
          email_service: 0,
          created_on: currentDate,
          logo_url: siteDetails.logo_url,
          zip: siteDetails.zip,
          website_url: siteDetails.website_url,
          company_logo: siteDetails.company_logo,
          company_seal: siteDetails.company_seal,
          hr_sign: siteDetails.hr_sign,
          cto_sign: siteDetails.cto_sign,
          watermark_logo: data,
        };
        console.log("aaaaa", req);
        backendApi(req).then((data) => {
          if (data.success === "1") {
            toast.success("Logo uploaded successfully", { containerId: "F" });
          } else {
            console.log("Error site details");
          }
        });
      } catch (err) {
        console.error("err", err);
        return;
      }
    } else {
      toast.warn("Please choose a file to upload", { containerId: "F" });
    }
  };
  const handleUploadHrSign = async (e) => {
    if (hrSign) {
      try {
        // const bucketParams = {
        //   Bucket: awsConfigDataState.s3Bucket,
        // };
        // AWS.config.update({
        //   accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
        //   secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
        //   region: "us-east-1",
        // });
        // s3 = new AWS.S3({
        //   apiVersion: "2006-03-01",
        //   params: bucketParams,
        // });
        // const timestamp = Date.now();
        // const startDateTime = moment(timestamp).startOf("day");
        // const formattedTimeStamp = startDateTime.format("DD MMM YYYY h:mm A");
        // const modifiedFileName = `${hrSign.name}_${formattedTimeStamp}`;
        // const data = await s3
        //   .upload({
        //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${modifiedFileName}`,
        //     Body: hrSign,
        //     ACL: "public-read",
        //   })
        //   .promise();
        const data = await uploadToS3(hrSign);
        console.log("Pathhh", data);
        const currentDate = new Date().toISOString();
        const req = {
          functionName: "siteUpdate",
          site_id: localStorage.getItem("siteId"),
          company_name: siteDetails.company_name,
          address: siteDetails.address,
          email_id: siteDetails.email_id,
          contact_no: siteDetails.contact_no,
          mobile_no: siteDetails.mobile_no,
          company_type: siteDetails.company_type,
          region_id: "",
          email_notification: 0,
          sms_notification: 0,
          email_service: 0,
          created_on: currentDate,
          logo_url: siteDetails.logo_url,
          zip: siteDetails.zip,
          website_url: siteDetails.website_url,
          company_logo: siteDetails.company_logo,
          company_seal: siteDetails.company_seal,
          hr_sign: data,
          cto_sign: siteDetails.cto_sign,
          watermark_logo: siteDetails.watermark_logo,
        };
        console.log("aaaaa", req);
        backendApi(req).then((data) => {
          if (data.success === "1") {
            toast.success("Sign uploaded successfully", { containerId: "F" });
          } else {
            console.log("Error site details");
          }
        });
      } catch (err) {
        console.error("err", err);
        return;
      }
    } else {
      toast.warn("Please choose a file to upload", { containerId: "F" });
    }
  };
  const handleUploadCompanySeal = async (e) => {
    if (companySeal) {
      try {
        // const bucketParams = {
        //   Bucket: awsConfigDataState.s3Bucket,
        // };
        // AWS.config.update({
        //   accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
        //   secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
        //   region: "us-east-1",
        // });
        // s3 = new AWS.S3({
        //   apiVersion: "2006-03-01",
        //   params: bucketParams,
        // });
        // const timestamp = Date.now();
        // const startDateTime = moment(timestamp).startOf("day");
        // const formattedTimeStamp = startDateTime.format("DD MMM YYYY h:mm A");
        // const modifiedFileName = `${companySeal.name}_${formattedTimeStamp}`;
        // const data = await s3
        //   .upload({
        //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${modifiedFileName}`,
        //     Body: companySeal,
        //     ACL: "public-read",
        //   })
        //   .promise();
        // console.log("Pathhh", data.Location);
        const data = await uploadToS3(hrSign);
        const currentDate = new Date().toISOString();
        const req = {
          functionName: "siteUpdate",
          site_id: localStorage.getItem("siteId"),
          company_name: siteDetails.company_name,
          address: siteDetails.address,
          email_id: siteDetails.email_id,
          contact_no: siteDetails.contact_no,
          mobile_no: siteDetails.mobile_no,
          company_type: siteDetails.company_type,
          region_id: "",
          email_notification: 0,
          sms_notification: 0,
          email_service: 0,
          created_on: currentDate,
          logo_url: siteDetails.logo_url,
          zip: siteDetails.zip,
          website_url: siteDetails.website_url,
          company_logo: siteDetails.company_logo,
          company_seal: data,
          hr_sign: siteDetails.hr_sign,
          cto_sign: siteDetails.cto_sign,
          watermark_logo: siteDetails.watermark_logo,
        };
        console.log("aaaaa", req);
        backendApi(req).then((data) => {
          if (data.success === "1") {
            toast.success("Seal uploaded successfully", { containerId: "F" });
          } else {
            console.log("Error site details");
          }
        });
      } catch (err) {
        console.error("err", err);
        return;
      }
    } else {
      toast.warn("Please choose a file to upload", { containerId: "F" });
    }
  };
  const handleUploadCtoSign = async (e) => {
    if (ctoSign) {
      try {
        // const bucketParams = {
        //   Bucket: awsConfigDataState.s3Bucket,
        // };
        // AWS.config.update({
        //   accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
        //   secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
        //   region: "us-east-1",
        // });
        // s3 = new AWS.S3({
        //   apiVersion: "2006-03-01",
        //   params: bucketParams,
        // });
        // const timestamp = Date.now();
        // const startDateTime = moment(timestamp).startOf("day");
        // const formattedTimeStamp = startDateTime.format("DD MMM YYYY h:mm A");
        // const modifiedFileName = `${ctoSign.name}_${formattedTimeStamp}`;
        // const data = await s3
        //   .upload({
        //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${modifiedFileName}`,
        //     Body: ctoSign,
        //     ACL: "public-read",
        //   })
        //   .promise();
        // console.log("Pathhh", data.Location);
        const data = await uploadToS3(ctoSign);
        const currentDate = new Date().toISOString();
        const req = {
          functionName: "siteUpdate",
          site_id: localStorage.getItem("siteId"),
          company_name: siteDetails.company_name,
          address: siteDetails.address,
          email_id: siteDetails.email_id,
          contact_no: siteDetails.contact_no,
          mobile_no: siteDetails.mobile_no,
          company_type: siteDetails.company_type,
          region_id: "",
          email_notification: 0,
          sms_notification: 0,
          email_service: 0,
          created_on: currentDate,
          logo_url: siteDetails.logo_url,
          zip: siteDetails.zip,
          website_url: siteDetails.website_url,
          company_logo: siteDetails.company_logo,
          company_seal: siteDetails.company_seal,
          hr_sign: siteDetails.hr_sign,
          cto_sign: data,
          watermark_logo: siteDetails.watermark_logo,
        };
        console.log("aaaaa", req);
        backendApi(req).then((data) => {
          if (data.success === "1") {
            toast.success("Sign uploaded successfully", { containerId: "F" });
          } else {
            console.log("Error site details");
          }
        });
      } catch (err) {
        console.error("err", err);
        return;
      }
    } else {
      toast.warn("Please choose a file to upload", { containerId: "F" });
    }
  };
  const [menuClick, setMenuClick] = useState(false);
  return (
    <div className="col-md-12">
      <div
        className="row xilliFirst "
        style={{ background: "transparent", padding: "0px" }}
      >
        <div className="col-md-12">
          <div className="row">
            <div className="xilliBrudcrb">
              <div className="crmPro">
                <div className="xiUser">
                  <div className="profile-crop-image">
                    <div
                      className="profile-pic crop-image "
                      onClick={() => {
                        setimagecrop(true);
                      }}
                    >
                      {hasDp && (
                        <label className="-label" for="file">
                          <FaCamera
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault(); // Prevent default file input dialog
                              toggleDropdown();
                            }}
                          />
                        </label>
                      )}
                      <img
                        onError={handleImageError}
                        src={
                          siteDetails?.logo_url
                            ? siteDetails?.logo_url
                            : defaultImg
                        }
                        id="output"
                        width="200"
                        alt="profile-img"
                      />
                    </div>
                    {imagecrop && (
                      <div
                        className="module_popup addPeople"
                        id="addsprint"
                      >
                        <div className="module_innerpopup module_bodypop">
                          <div className="module_headdiv">
                            <h4 className="popup_head">
                              {" "}
                              Upload Profile Picture
                            </h4>
                            <div className="module_close">
                              <Icon.X
                                color="grey"
                                onClick={() => {
                                  setimagecrop(false);
                                }}
                                size={18}
                              />
                            </div>
                          </div>
                          <div style={{ width: "100%" }}>
                            <Avatar
                              width={"100%"}
                              height={300}
                              onCrop={onCrop}
                              onClose={onClose}
                              label={
                                <span className="click_upload">
                                  Click here to Upload
                                </span>
                              }
                              // src={src}
                              shadingColor={"#474649"}
                              backgroundColor={"#474649"}
                              style={{ color: "blue" }}
                            />
                          </div>
                          <div className="button-wrapper mt-2">
                            <button
                              className="btn-save"
                              onClick={saveCropImage}
                              label="Save"
                            >
                              Crop
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {isDropdownVisible && (
                      <>
                        <div
                          className="removePic"
                          onClick={removePic}
                        >
                          <p>
                            <FaTrash color="red" /> &nbsp;Remove
                            Photo
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Company Name
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        name="company_name"
                        id="company_name"
                        className="form-control"
                        placeholder="Company Name"
                        value={siteDetails?.company_name}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Email Id
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Last Name"
                        name="email_id"
                        id="email_id"
                        value={siteDetails?.email_id}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Address
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Email Id"
                        name="address"
                        id="address"
                        value={siteDetails?.address}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Contact Number
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Contact Number"
                        name="contact_no"
                        id="contact_no"
                        maxLength={12}
                        value={siteDetails?.contact_no}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Mobile Number
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Mobile Number"
                        name="mobile_no"
                        id="mobile_no"
                        maxLength={12}
                        value={siteDetails?.mobile_no}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Company Type
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <select
                        className="form-control"
                        name="company_type"
                        value={siteDetails?.company_type}
                        onChange={handleChange}
                      >
                        <option value="">
                          Select a Company type
                        </option>
                        {companyTypes.map((companyType) => (
                          <option
                            key={companyType}
                            value={companyType}
                          >
                            {companyType}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Zip code
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Zip Code"
                        name="zip"
                        id="zip"
                        value={siteDetails?.zip}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-label">
                        Website URL
                        <span className="text-danger ml-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Website URL"
                        name="website_url"
                        id="website_url"
                        value={siteDetails?.website_url}
                      />
                    </div>
                  </div>
                </div>
                <div className="childIssueses">
                  <button
                    className="btn-btn btn btn-btn1 btn-sm me-2"
                    onClick={goBack}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-btn btn btn-btn2 btn-sm"
                    onClick={() => saveDetails()}
                  >
                    Save
                  </button>
                </div>
                <br />
                <br />
                <hr class="horizontal dark"></hr>
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-4 mb-4 d-flex flex-coulmn">
                        <div className="form-group mb-0">
                          <label className="form-label">
                            Logo Upload
                          </label>
                          <span className="browse-files">
                            <input
                              type="file"
                              onChange={(e) => {
                                handleFileUploadLogo(e);
                              }}
                            />
                          </span>
                          <span className="d-flex flex-column my-2">
                            {filesLogo ? (
                              <img
                                src={`${URL.createObjectURL(
                                  filesLogo
                                )}`}
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            ) : (
                              <img
                                src={
                                  siteDetails.company_logo ||
                                  PlaceHolder
                                }
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            )}

                            {filesLogo && (
                              <button
                                className="btn-btn btn btn-btn2 btn-sm mt-2"
                                style={{ width: "fit-content" }}
                                onClick={handleUploadLogo}
                              >
                                Upload
                              </button>
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-4 mb-4">
                        <div className="form-group mb-0">
                          <label className="form-label">
                            Watermark Upload
                          </label>
                          <span className="browse-files">
                            <input
                              type="file"
                              onChange={(e) => {
                                handleFileUploadWatermarkLogo(
                                  e
                                );
                              }}
                            />
                          </span>
                          <span className="d-flex flex-column my-2">
                            {watermarkLogo ? (
                              <img
                                src={`${URL.createObjectURL(
                                  watermarkLogo
                                )}`}
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            ) : (
                              <img
                                src={
                                  siteDetails.watermark_logo ||
                                  PlaceHolder
                                }
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            )}
                            {watermarkLogo && (
                              <button
                                className="btn-btn btn btn-btn2 btn-sm mt-2"
                                style={{ width: "fit-content" }}
                                onClick={
                                  handleUploadWatermarkLogo
                                }
                              >
                                Upload
                              </button>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-4">
                        <div className="form-group mb-0">
                          <label className="form-label">
                            Company Seal Upload
                          </label>
                          <span className="browse-files">
                            <input
                              type="file"
                              onChange={(e) => {
                                handleFileUploadComapnySeal(e);
                              }}
                            />
                          </span>
                          <span className="d-flex flex-column my-2">
                            {companySeal ? (
                              <img
                                src={`${URL.createObjectURL(
                                  companySeal
                                )}`}
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            ) : (
                              <img
                                src={
                                  siteDetails.company_seal ||
                                  PlaceHolder
                                }
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            )}
                            {companySeal && (
                              <button
                                className="btn-btn btn btn-btn2 btn-sm mt-2"
                                style={{ width: "fit-content" }}
                                onClick={
                                  handleUploadCompanySeal
                                }
                              >
                                Upload
                              </button>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-4">
                        <div className="form-group mb-0">
                          <label className="form-label">
                            HR Sign Upload
                          </label>
                          <span className="browse-files">
                            <input
                              type="file"
                              onChange={(e) => {
                                handleFileUploadHrSign(e);
                              }}
                            />
                          </span>
                          <span className="d-flex flex-column my-2">
                            {hrSign ? (
                              <img
                                src={`${URL.createObjectURL(
                                  hrSign
                                )}`}
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            ) : (
                              <img
                                src={
                                  siteDetails.hr_sign ||
                                  PlaceHolder
                                }
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            )}
                            {hrSign && (
                              <button
                                className="btn-btn btn btn-btn2 btn-sm mt-2"
                                style={{ width: "fit-content" }}
                                onClick={handleUploadHrSign}
                              >
                                Upload
                              </button>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-4">
                        <div className="form-group mb-0">
                          <label className="form-label">
                            CTO Sign Upload
                          </label>
                          <span className="browse-files">
                            <input
                              type="file"
                              onChange={(e) => {
                                handleFileUploadCtoSign(e);
                              }}
                            />
                          </span>
                          <span className="d-flex flex-column my-2">
                            {ctoSign ? (
                              <img
                                src={`${URL.createObjectURL(
                                  ctoSign
                                )}`}
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            ) : (
                              <img
                                src={
                                  siteDetails.cto_sign ||
                                  PlaceHolder
                                }
                                width="200"
                                alt="profile-img"
                                className="img-fluid img-upload"
                              />
                            )}

                            {ctoSign && (
                              <button
                                className="btn-btn btn btn-btn2 btn-sm mt-2"
                                style={{ width: "fit-content" }}
                                onClick={handleUploadCtoSign}
                              >
                                Upload
                              </button>
                            )}
                          </span>
                        </div>
                      </div>
                      <hr class="horizontal dark"></hr>
                    </div>
                  </div>
                  {documents?.length > 0 && (
                    <div className="col-md-8 m-auto">
                      <div className="row m-auto">
                        <div className="col-xl-4 mb-3">
                          <div className="form-group mb-0">
                            <label
                              htmlFor=""
                              className="form-label"
                            >
                              Document Type
                            </label>
                            <select
                              className="form-control"
                              name="company_type"
                              value={documentDetails}
                              onChange={
                                handleDocumentTypeChange
                              }
                            >
                              <option value="">
                                Select a Company type
                              </option>
                              <option value="NDA Doc1">
                                NDA Doc
                              </option>
                              <option value="CONTRACTOR TERMS AND CONDITIONS">
                                CONTRACTOR TERMS AND CONDITIONS
                              </option>
                              <option value="ACCEPTANCE FORM">
                                ACCEPTANCE FORM
                              </option>
                              <option value="HR FORM 1">
                                HR FORM 1
                              </option>
                              <option value="HR FORM 2">
                                HR FORM 2
                              </option>
                              <option value="EMPLOYEE TERMS AND CONDITIONS">
                                EMPLOYEE TERMS AND CONDITIONS
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-8 mb-3">
                          <div className="form-group mb-0">
                            <label className="form-label">
                              Browse
                            </label>
                            <div className="d-flex">
                              <div className="browse-files">
                                <input
                                  type="file"
                                  onChange={(e) => {
                                    handleFileUpload(e);
                                  }}
                                />
                              </div>
                              {files && (
                                <button
                                  className="btn-btn btn btn-btn2 btn-sm"
                                  onClick={handleUpload}
                                >
                                  Upload
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr class="horizontal dark"></hr>
                      <div className="table-responsive ml-3">
                        <table className="table">
                          <thead style={{ height: "30px" }}>
                            <tr>
                              <th style={{ width: "20px" }}>
                                #
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  width: "200px",
                                }}
                              >
                                Document Name
                              </th>
                              {/* <th style={{ textAlign: "left", width: "180px" }}>
            Job Opening Details
        </th> */}
                              <th
                                style={{
                                  textAlign: "left",
                                  width: "50px",
                                }}
                              >
                                Document
                              </th>
                              <th
                                style={{
                                  textAlign: "center",
                                  width: "50px",
                                }}
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          {documents?.map((document, index) => {
                            return (
                              <tbody>
                                <tr>
                                  <td
                                    aria-label="Lead Summary"
                                    style={{
                                      verticalAlign: "top",
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    aria-label="Lead Summary"
                                    style={{
                                      verticalAlign: "top",
                                    }}
                                  >
                                    {document.doc_name}
                                  </td>
                                  <td
                                    aria-label="Lead Summary"
                                    style={{
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <div>
                                      <FaEye
                                        color="#7b68ee"
                                        title="View"
                                        size={17}
                                        className="ml-2"
                                        onClick={() =>
                                          openFileInNewTab(
                                            document
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                  <td
                                    aria-label="View"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <div className="mt-1">
                                      <Switch
                                        className="switch_case mt-1 mr-2"
                                        handleDiameter={16}
                                        height={18}
                                        width={40}
                                        checked={
                                          document.is_active ===
                                            1
                                            ? true
                                            : false
                                        }
                                        onChange={(checked) => {
                                          changeActive(
                                            checked,
                                            document
                                          );
                                        }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })}
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteDetails;